import {Plural, Trans} from '@lingui/macro';
import React, {FC} from 'react';
import styled from 'styled-components';

import {Handler, HandlerOf} from '../../../../libs/shared/helpers/src/react/reactHelpers';
import {Button} from '../../../../libs/shared/ui/src/components/buttons/button';
import {ButtonVariantsEnum} from '../../../../libs/shared/ui/src/components/buttons/buttonConstants';
import {computeMultiSelectCheckboxState} from '../../../components/common/table/helpers/tableHelpers';
import {TableMultiSelectHeaderRow} from '../../../components/common/table/tableMultiSelectHeaderRow';

/*
 * Props.
 */

interface RuleListMultiSelectHeaderProps {
  onMultiSelectChange: HandlerOf<boolean>;
  selectedBundlesIds: ReadonlyArray<number>;
  numberOfBundlesInList: number;
  onDeleteClick: Handler;
  onSetActiveClick: Handler;
  onSetInactiveClick: Handler;
}

/*
 * Style.
 */

const StyledButtonsWrapper = styled.div`
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: min-content;
  grid-gap: 8px;
`;

/*
 * Component.
 */

export const RuleListMultiSelectHeader: FC<RuleListMultiSelectHeaderProps> = (props) => {
  const {
    onMultiSelectChange,
    selectedBundlesIds,
    numberOfBundlesInList,
    onDeleteClick,
    onSetActiveClick,
    onSetInactiveClick,
  } = props;

  const multiSelectCheckboxState = computeMultiSelectCheckboxState(
    selectedBundlesIds.length,
    numberOfBundlesInList,
  );

  const renderButtons = () => (
    <StyledButtonsWrapper>
      <Button onClick={onSetActiveClick}>
        <Trans id="rule-list-activate-selection">Activate</Trans>
      </Button>
      <Button onClick={onSetInactiveClick}>
        <Trans id="rule-list-deactivate-selection">Deactivate</Trans>
      </Button>
      <Button onClick={onDeleteClick} variant={ButtonVariantsEnum.SECONDARY_DANGER}>
        <Trans id="rule-list-delete-selection">Delete</Trans>
      </Button>
    </StyledButtonsWrapper>
  );

  return (
    <TableMultiSelectHeaderRow
      multiSelectStatus={multiSelectCheckboxState}
      onMultiSelectChange={onMultiSelectChange}
      renderTotalItemsLabel={() => (
        <Plural
          id="settings-rule-bundles-bulkactionrulebundlesselected"
          value={selectedBundlesIds.length}
          zero="No rules selected"
          one="1 rule selected"
          other="# bundles selected"
        />
      )}
    >
      {renderButtons()}
    </TableMultiSelectHeaderRow>
  );
};
